<template>
    <panel v-if="isVerifiedUser"
        :panel="this.panel" />
</template>

<script>
    import Panel from '../Panel';
    import { Role } from '../../../helpers/role';

    export default {
        props: {
            panel: Object
        },
        components: {
            Panel
        },
        computed: {
            isVerifiedUser() {
                return this.$store.getters.userRoles.includes(Role.VerifiedUser)
                    || this.$store.getters.userRoles.includes(Role.Participant);
            },
        }
    }
</script>
